// extracted by mini-css-extract-plugin
module.exports = {"fade":"Hero_fade__Ena33","desktopImgContainer":"Hero_desktopImgContainer__9D_wK"};